/* ============================================================
   FantasyDice Dragon — Fire Particles + Torn Edge + Dividers
   Duplicate theme only — NOT published
   ============================================================ */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     DRAGON FIRE PARTICLE SYSTEM
     Two layers: large slow embers (deep red→orange)
                 small fast sparks (amber→gold)
     Particles shift color red→gold as they ascend.
     ============================================================ */

  function initDragonFire() {
    if (prefersReduced) return;

    var hero = document.querySelector('.banner, .hero, [class*="slideshow"]');
    if (!hero) return;

    hero.style.position = 'relative';
    hero.style.overflow = 'hidden';

    /* Remove old phase2 canvas */
    var old = document.getElementById('fd-ember-canvas');
    if (old) old.remove();

    /* Fog overlay */
    if (!hero.querySelector('.fd-fog')) {
      var fog = document.createElement('div');
      fog.className = 'fd-fog';
      hero.insertBefore(fog, hero.firstChild);
    }

    /* Vignette */
    if (!hero.querySelector('.fd-vignette')) {
      var vig = document.createElement('div');
      vig.className = 'fd-vignette';
      hero.insertBefore(vig, hero.firstChild);
    }

    /* Fire canvas */
    var canvas = document.createElement('canvas');
    canvas.id = 'fd-fire-canvas';
    canvas.style.cssText =
      'position:absolute;inset:0;width:100%;height:100%;' +
      'pointer-events:none;z-index:2;';
    hero.insertBefore(canvas, hero.firstChild);

    var ctx = canvas.getContext('2d');
    var W, H;

    function resize() {
      W = canvas.width  = hero.offsetWidth;
      H = canvas.height = hero.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function mkEmber() {
      return {
        x:     W * 0.10 + Math.random() * W * 0.80,
        y:     H + 10,
        r:     Math.random() * 3.2 + 1.3,
        vy:    Math.random() * 0.62 + 0.25,
        vx:    (Math.random() - 0.5) * 0.52,
        life:  1,
        decay: Math.random() * 0.0022 + 0.0008,
        hue:   Math.random() * 22 + 6,
        sat:   95,
        lit:   Math.random() * 22 + 42,
        kind:  'ember'
      };
    }

    function mkSpark() {
      return {
        x:     W * 0.20 + Math.random() * W * 0.60,
        y:     H + 4,
        r:     Math.random() * 1.1 + 0.28,
        vy:    Math.random() * 1.5  + 0.65,
        vx:    (Math.random() - 0.5) * 0.95,
        life:  1,
        decay: Math.random() * 0.005 + 0.0022,
        hue:   Math.random() * 28 + 38,
        sat:   100,
        lit:   Math.random() * 18 + 64,
        kind:  'spark'
      };
    }

    var particles = [];
    for (var s = 0; s < 25; s++) {
      var p = Math.random() < 0.55 ? mkEmber() : mkSpark();
      p.y = Math.random() * H;
      particles.push(p);
    }

    var raf = null;

    function drawBase() {
      var g = ctx.createLinearGradient(0, H * 0.72, 0, H);
      g.addColorStop(0,   'rgba(155,38,0,0)');
      g.addColorStop(0.6, 'rgba(110,25,0,0.08)');
      g.addColorStop(1,   'rgba(65,12,0,0.16)');
      ctx.fillStyle = g;
      ctx.fillRect(0, H * 0.72, W, H * 0.28);
    }

    function frame() {
      ctx.clearRect(0, 0, W, H);
      drawBase();

      if (particles.length < 90) {
        if (Math.random() < 0.50) particles.push(mkEmber());
        if (Math.random() < 0.35) particles.push(mkSpark());
      }

      particles = particles.filter(function (p) {
        return p.life > 0 && p.y > -35;
      });

      particles.forEach(function (p) {
        p.y   -= p.vy;
        p.x   += p.vx + Math.sin(p.y * 0.024 + p.x * 0.009) * 0.36;
        p.life -= p.decay;

        var ascent = Math.max(0, Math.min(1, 1 - p.y / H));
        var h = p.hue + ascent * 36;
        var l = p.lit + ascent * 18;
        var a = Math.max(0, p.life * 0.80);

        ctx.save();
        ctx.globalAlpha = a;
        ctx.shadowBlur  = p.kind === 'ember' ? 14 : 8;
        ctx.shadowColor = 'hsl(' + (h + 18) + ',100%,' + Math.min(100, l + 28) + '%)';

        var rad = p.r * 2.8;
        var gr  = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, rad);
        gr.addColorStop(0,   'hsl(' + (h + 22) + ',' + p.sat + '%,' + Math.min(100, l + 28) + '%)');
        gr.addColorStop(0.4, 'hsla(' + h + ',' + p.sat + '%,' + l + '%,0.55)');
        gr.addColorStop(1,   'hsla(' + h + ',' + p.sat + '%,' + l + '%,0)');

        ctx.fillStyle = gr;
        ctx.beginPath();
        ctx.arc(p.x, p.y, rad, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });

      raf = requestAnimationFrame(frame);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { if (!raf) frame(); }
        else { cancelAnimationFrame(raf); raf = null; }
      });
    });
    io.observe(hero);
    frame();
  }

  /* ============================================================
     TORN PAINTED EDGE
     Organic SVG painted edge injected between hero and next section.
     Fill color matches the site warm-dark background.
     ============================================================ */

  function injectTornEdge() {
    /* Find the hero shopify section */
    var heroSection = null;
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (sec) {
      if (!heroSection && sec.querySelector('.banner, [class*="slideshow"]')) {
        heroSection = sec;
      }
    });
    if (!heroSection) return;

    /* Don't double-inject */
    var next = heroSection.nextElementSibling;
    if (next && next.classList.contains('fd-torn-edge')) return;

    var edge = document.createElement('div');
    edge.className = 'fd-torn-edge';
    edge.setAttribute('aria-hidden', 'true');

    /* Organic torn path — irregular like a painted/clawed edge.
       Varies between y=5 and y=60 across the 80px-tall viewBox.
       Fill = site background warm dark (#0E0905). */
    edge.innerHTML =
      '<svg viewBox="0 0 1440 80" preserveAspectRatio="none"'
      + ' xmlns="http://www.w3.org/2000/svg">'
      + '<path d="'
      + 'M0,52 '
      + 'C 72,38 144,64 216,46 '
      + 'C 288,28 360,60 432,42 '
      + 'C 504,24 576,56 648,35 '
      + 'C 720,14 792,50 864,30 '
      + 'C 936,10 1008,46 1080,26 '
      + 'C 1152,6 1224,42 1296,22 '
      + 'C 1332,12 1368,28 1404,14 '
      + 'C 1422,7 1431,4 1440,2 '
      + 'L 1440,80 L 0,80 Z'
      + '" fill="#0E0905"/>'
      + '</svg>';

    heroSection.insertAdjacentElement('afterend', edge);
  }

  /* ============================================================
     FIRE-THEMED SECTION DIVIDERS
     Replaces the diamond dividers from phase2.js.
     ============================================================ */

  function reinjectFireDividers() {
    /* Remove old */
    document.querySelectorAll('.fd-divider').forEach(function (d) { d.remove(); });

    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (sec, i) {
      if (i === 0) return;

      var div = document.createElement('div');
      div.className = 'fd-divider';
      div.setAttribute('aria-hidden', 'true');

      div.innerHTML =
        '<svg viewBox="0 0 1200 44" preserveAspectRatio="none"'
        + ' xmlns="http://www.w3.org/2000/svg">'
        + '<defs>'
        +   '<linearGradient id="fdl' + i + '" x1="0" x2="1">'
        +     '<stop offset="0" stop-color="rgba(192,57,43,0)"/>'
        +     '<stop offset="1" stop-color="rgba(192,57,43,0.32)"/>'
        +   '</linearGradient>'
        +   '<linearGradient id="fdr' + i + '" x1="0" x2="1">'
        +     '<stop offset="0" stop-color="rgba(192,57,43,0.32)"/>'
        +     '<stop offset="1" stop-color="rgba(192,57,43,0)"/>'
        +   '</linearGradient>'
        + '</defs>'
        + '<line x1="0" y1="22" x2="520" y2="22"'
        +   ' stroke="url(#fdl' + i + ')" stroke-width="1"/>'
        + '<line x1="680" y1="22" x2="1200" y2="22"'
        +   ' stroke="url(#fdr' + i + ')" stroke-width="1"/>'
        /* Flame cluster */
        + '<path d="M593,34 C594,24 597,14 600,8 C603,14 606,24 607,34 Z"'
        +   ' fill="rgba(192,57,43,0.4)"/>'
        + '<path d="M596,34 C597,27 599,19 600,15 C601,19 603,27 604,34 Z"'
        +   ' fill="rgba(212,175,55,0.6)"/>'
        + '<circle cx="600" cy="36" r="2.2" fill="rgba(212,175,55,0.45)"/>'
        + '<circle cx="586" cy="22" r="1.4" fill="rgba(192,57,43,0.28)"/>'
        + '<circle cx="614" cy="22" r="1.4" fill="rgba(192,57,43,0.28)"/>'
        + '</svg>';

      sec.insertAdjacentElement('beforebegin', div);
    });
  }

  /* ============================================================
     INIT
     ============================================================ */

  function init() {
    initDragonFire();
    injectTornEdge();
    reinjectFireDividers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
